import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import styles from './envelopeSummary.css';
import { ErrorIcon } from '../../Icon';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import {FormattedMessage, useIntl} from 'react-intl';
import {roleMap, signingOptionMap} from '../../../mappers/translationMappers';

export const EnvelopeSummarySigners = ({
    name,
    role,
    email,
    contact,
    signingOrder,
    signingMethod,
    isDuplicate
}) => {
    const intl = useIntl();
    return (
        <div
            className={
                email && contact && !isDuplicate
                    ? styles.signerReview
                    : styles.signerReviewError
            }
        >
            <div>
                <AccountCircleIcon className={styles.reviewAvatar} color="disabled"/>
            </div>
            <div className={styles.signerReviewDiv}>
                <div className={styles.signerReviewInfo}>
                    <div className="d-flex flex-row justify-content-between">
                        <p className="d-flex" data-sl="mask">{name}</p>
                        <div className={styles.reviewOrder}>
                            <ErrorIcon
                                className={
                                    email && contact && !isDuplicate
                                        ? 'uxf-icon d-inline-block mb-0 mr-1 invisible'
                                        : 'uxf-icon d-inline-block mb-0 mr-1 visible'
                                }
                            />
                            <Chip
                                color="primary"
                                label={intl.formatMessage({id:'labels.ORDER'}) + ': ' + signingOrder}
                                size="small"
                                variant="outlined"
                            />
                        </div>
                    </div>
                    <span className="d-flex flex-row">
                        <strong><FormattedMessage id={'labels.EMAIL'}/>:&nbsp;</strong>
                        <span data-sl="mask">{email}</span>
                    </span>
                    <div className="d-flex flex-row justify-content-between">
                        <span data-sl="mask">
                            <strong><FormattedMessage id={'labels.MOBILE'}/>:</strong>
                            <span data-sl="mask">{contact}</span>
                        </span>
                        <span>
                            <strong><FormattedMessage id={'labels.OPTION'}/>:</strong> {signingMethod && signingOptionMap[signingMethod.toUpperCase()]}
                        </span>
                        <span>
                            <strong><FormattedMessage id={'labels.ROLE'}/>:</strong> {role && roleMap[role.toUpperCase()]}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

EnvelopeSummarySigners.propTypes = {
    name: PropTypes.string,
    role: PropTypes.string,
    email: PropTypes.string,
    contact: PropTypes.string,
    signingOrder: PropTypes.number,
    signingMethod: PropTypes.string
};
